import React, { Fragment } from 'react';
import moment from 'moment';
import './paquete-detalle-transporte.css';
import { withTranslation } from 'react-i18next';
import CityName from '../../../../commons/iataRenderService';

const Transporte = (props) => {
  const { t } = props;
  if (props.transporte.transporteAereo === null) {
    return null;
  }
  if (
    props.transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaLlegada === '0001-01-01T00:00:00'
            && props.transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaLlegada === '0001-01-01T00:00:00'
            && props.transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal.fechaSalida === '0001-01-01T00:00:00'
            && props.transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal.fechaLlegada === '0001-01-01T00:00:00'
  ) {
    return null;
  }

  const getDate = (value, format, returnedText = '', appendedText = '') => {
    if (
      value === null
        || value === '0001-01-01T00:00:00'
        || value === undefined
    ) {
      return returnedText;
    }

    if (format.toUpperCase().includes('H') && value.includes('00:00:00')) {
      return returnedText;
    }

    return `${moment(value).format(format)} ${appendedText}`;
  };

  const diaS = getDate(props.ida.segmentoPrincipal.fechaSalida, 'ddd D');
  const mesS = getDate(props.ida.segmentoPrincipal.fechaSalida, 'MMM YYYY');
  const diaL = getDate(props.vuelta.segmentoPrincipal.fechaLlegada, 'ddd D');
  const mesL = getDate(props.vuelta.segmentoPrincipal.fechaLlegada, 'MMM YYYY');
  const horaS = getDate(props.transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaSalida, 'HH:mm');
  const horaSS = getDate(props.transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaLlegada, 'HH:mm');
  const horaL = getDate(props.transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal.fechaSalida, 'HH:mm');
  const horaLL = getDate(props.transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal.fechaLlegada, 'HH:mm');
  return (
    <Fragment>
      { props.ida.segmentoPrincipal.ciudadOrigenIata || props.ida.segmentoPrincipal.ciudadDestinoIata == null
        ? null : (
          <div className='simplification'>
            <CityName code={props.ida.segmentoPrincipal.ciudadOrigenIata} />
            {' '}
            (
            {props.ida.segmentoPrincipal.ciudadOrigenIata}
            )
            -
            <CityName code={props.ida.segmentoPrincipal.ciudadDestinoIata} />
            {' '}
            (
            {props.ida.segmentoPrincipal.ciudadDestinoIata}
            )
            {props.transporte.transporteAereo.nombreLineaAerea !== null ? (
              <span>
                {`${t('layout:packages.details.traveling_with')}: `}
                <b>{props.transporte.transporteAereo.nombreLineaAerea}</b>
              </span>
            ) : null}
          </div>
        )}
      <div className='box-seg'>
        <div className='item-content in-left'>
          <span className='container-icon bg-mbr-color-primario'>
            <i className='fas fa-arrow-right' />
          </span>
          <span>
            <span className='uppercase'>{diaS}</span>
            &nbsp;
            <span className='uppercase'>{mesS}</span>
          </span>
          <i className='fas fa-chevron-right' style={{ padding: '0 9px' }} />
        </div>
        { props.ida.segmentoPrincipal.ciudadOrigenIata == null || props.ida.segmentoPrincipal.ciudadDestinoIata == null ? (
          <div className='item-content middle'>
            <span className='internal-items'>
              <b>
                {horaS}
                {' '}
                hs
                {' '}
                {props.ida.segmentoPrincipal.aeropuertoOrigen}
              </b>
              {' '}
              -
              <b>
                {horaSS}
                {' '}
                hs
                {' '}
                {props.ida.segmentoPrincipal.aeropuertoLlegada}
              </b>
            </span>
          </div>
        ) : (
          <div className='item-content middle'>
            <span className='internal-items'>
              <b>
                {horaS}
                {' '}
                hs
                {' '}
                {props.ida.segmentoPrincipal.ciudadOrigenIata}
              </b>
              {' '}
              -
              <b>
                {horaSS}
                {' '}
                hs
                {' '}
                {props.ida.segmentoPrincipal.ciudadDestinoIata}
              </b>
            </span>
          </div>
        )}
        <div className='item-content in-left'>
          <i className='fas fa-chevron-right' style={{ padding: '0 9px' }} />
          <span className='container-icon bg-mbr-color-primario'>
            <i className='fas fa-arrow-left ' />
          </span>
          <span>
            <span className='uppercase'>{diaS}</span>
            &nbsp;
            <span className='uppercase'>{mesS}</span>
          </span>
        </div>
      </div>
      <div className='box-seg'>
        <div className='item-content in-left'>
          <span className='container-icon bg-mbr-color-primario'>
            <i className='fas fa-arrow-right' />
          </span>
          <span>
            <span className='uppercase'>{diaL}</span>
            &nbsp;
            <span className='uppercase'>{mesL}</span>
          </span>
          <i className='fas fa-chevron-right' style={{ padding: '0 9px' }} />
        </div>
        { props.vuelta.segmentoPrincipal.ciudadOrigenIata == null || props.vuelta.segmentoPrincipal.ciudadDestinoIata == null ? (
          <div className='item-content middle'>
            <span className='internal-items'>
              <b>
                {horaL}
                {' '}
                hs
                {' '}
                {props.vuelta.segmentoPrincipal.aeropuertoOrigen}
              </b>
              {' '}
              -
              <b>
                {horaLL}
                {' '}
                hs
                {' '}
                {props.vuelta.segmentoPrincipal.aeropuertoLlegada}
              </b>
            </span>
          </div>
        ) : (
          <div className='item-content middle'>
            <span className='internal-items'>
              <b>
                {horaL}
                {' '}
                hs
                {' '}
                {props.vuelta.segmentoPrincipal.ciudadOrigenIata}
              </b>
              {' '}
              -
              <b>
                {horaLL}
                {' '}
                hs
                {' '}
                {props.vuelta.segmentoPrincipal.ciudadDestinoIata}
              </b>
            </span>
          </div>
        )}
        <div className='item-content in-left'>
          <i className='fas fa-chevron-right' style={{ padding: '0 9px' }} />
          <span className='container-icon bg-mbr-color-primario'>
            <i className='fas fa-arrow-left ' />
          </span>
          <span>
            <span className='uppercase'>{diaL}</span>
            &nbsp;
            <span className='uppercase'>{mesL}</span>
          </span>
        </div>
      </div>
    </Fragment>
  );
};
export default withTranslation()(Transporte);
